import PropTypes from 'prop-types';

import { PartnerItemType } from '../../../api/types';
import { APP_SETTINGS } from '../../../app-settings';
import { useApiContext } from '../../../context/api-provider';
import { Hyperlink } from '../../hyperlink/hyperlink';
import { Image } from '../../image/image';

const DEFAULT_REL = 'noreferrer';

export function FooterPartner({ className, partner }) {
  const { url, logo, rel } = partner;
  const { apiConfig } = useApiContext();
  const isLinkEnabled = !APP_SETTINGS.MIRRORS_WITH_HIDDEN_URLS?.[apiConfig.sportsbookFrontendOrigin];

  if (url && isLinkEnabled) {
    return (
      <Hyperlink className={className} rel={rel || DEFAULT_REL} target="_blank" url={url}>
        <Image alt={logo?.alt} loading="lazy" src={logo?.url} noProxy />
      </Hyperlink>
    );
  }

  return (
    <div className={className}>
      <Image alt={logo?.alt} loading="lazy" src={logo?.url} noProxy />
    </div>
  );
}

FooterPartner.propTypes = {
  className: PropTypes.string,
  partner: PartnerItemType.isRequired,
};

FooterPartner.defaultProps = {
  className: undefined,
};
